import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { EmojiPicker, EmojiPickerContent, EmojiPickerFooter, EmojiPickerSearch } from "@/components/ui/emoji-picker";
import { Smiley } from "@phosphor-icons/react";
export interface EmojiSelectorProps {
  selectedEmoji: string;
  isLoading: boolean;
  onEmojiSelect: (emoji: string) => void;
}
export function EmojiSelector(t0) {
  const $ = _c(15);
  const {
    selectedEmoji,
    isLoading,
    onEmojiSelect
  } = t0;
  let t1;
  if ($[0] !== selectedEmoji) {
    t1 = selectedEmoji ? <span className="text-lg">{selectedEmoji}</span> : <Smiley className="w-5 h-5 text-muted-foreground" weight="fill" />;
    $[0] = selectedEmoji;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isLoading || $[3] !== t1) {
    t2 = <PopoverTrigger asChild={true}><Button variant="ghost" size="icon" className="h-11 w-11 shrink-0 rounded-none hover:bg-muted-foreground/10" disabled={isLoading}>{t1}</Button></PopoverTrigger>;
    $[2] = isLoading;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onEmojiSelect) {
    t3 = emoji => {
      onEmojiSelect(emoji.emoji);
    };
    $[5] = onEmojiSelect;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <EmojiPickerSearch placeholder="Search emoji..." />;
    t5 = <EmojiPickerContent className="h-[220px]" />;
    t6 = <EmojiPickerFooter className="border-t-0 p-1.5" />;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3) {
    t7 = <PopoverContent className="w-[280px] p-0 rounded-lg" side="top" align="start" sideOffset={12}><div className="flex h-[300px] w-full items-center justify-center p-0"><EmojiPicker onEmojiSelect={t3} className="h-full">{t4}{t5}{t6}</EmojiPicker></div></PopoverContent>;
    $[10] = t3;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t7) {
    t8 = <Popover>{t2}{t7}</Popover>;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}